import Path from "../../../services/paths";
import ActivityPlanActions from "../../prat_actions/activityPlan/activityPlanActions";
import utils from "../../common/utils";
import axios from "axios";

class ActivityPlanMiddleware {
  static getActivityPlan(
    pageNo,
    selectedPromotionLevel,
    selectedProductCategories,
    selectedProductBrands,
    selectedProductMasterSkus,
    selectedProductSkus,
    selectedYear,
    selectedActivityStatus,
    selectedPromotionType
  ) {
    
    let url = `${Path.GET_ACTIVITY_PLAN}?`;
    if (pageNo) {
      url += `page=${pageNo}&`;
    }
    if (Array.isArray(selectedProductCategories)) {
        selectedProductCategories.forEach(element => {
        url += `category=${element}&`;
      });
    }
    if (Array.isArray(selectedProductBrands)) {
        selectedProductBrands.forEach(element => {
        url += `brand=${element}&`;
      });
    }
    if (Array.isArray(selectedProductMasterSkus)) {
        selectedProductMasterSkus.forEach(element => {
        url += `master_sku=${element}&`;
      });
    }
    if (Array.isArray(selectedProductSkus)) {
        selectedProductSkus.forEach(element => {
        url += `sku=${element}&`;
      });
    }
    if (selectedYear) {
        url += `year=${selectedYear}&`;
    }
    if (selectedPromotionLevel) {
        url += `promotion_level=${selectedPromotionLevel}&`;
    }
    if (Array.isArray(selectedActivityStatus)) {
        selectedActivityStatus.forEach(element => {
        url += `activity_status=${element}&`;
      });
    }
    if (selectedPromotionType) {
        url += `promotion_type=${selectedPromotionType}&`;
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(ActivityPlanActions.activityPlanRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 404) {
                dispatch(ActivityPlanActions.activityPlanFailed());
              } else {
                dispatch(ActivityPlanActions.activityPlanSuccessul(res));
              }
            })
            .catch(error => {
              dispatch(ActivityPlanActions.activityPlanFailed());
            });
        })
        .catch(error => {
          dispatch(ActivityPlanActions.activityPlanFailed(error));
        });
    };
  }
}

export default ActivityPlanMiddleware;
